<template>
  <div class="player-volume-wrap">
    <div class="player-volume-wrap__volume-slider-overlay"
         v-show="isShowVolumeBar"
         @click.self="closeVolumeBar"></div>
    <input type="range"
           v-show="isShowVolumeBar"
           v-model="volume"
           step=0.1
           min=0.0
           max=1.0
           orient="vertical">
    <div class="player-time-inner">
      <v-btn icon v-if="mute === false"
             class="player-icon player-icon-volume-down"
             @click="toggleVolumeBar">
        <v-icon>volume_up</v-icon>
      </v-btn>
      <v-btn icon
             v-else
             class="player-icon player-icon-volume-down"
             @click="toggleVolumeBar">
        <v-icon>volume_off</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MuteBtn',
  data () {
    return {
      audio: undefined,
      preVolume: 0.8, // mute前のvol
      volume: 0.8,
      isShowVolumeBar: false,
      mute: false
    }
  },
  mounted () {
    this.audio = document.querySelector('#audio')
  },
  watch: {
    volume (vol) {
      this.audio.volume = vol
      if (parseFloat(vol) === 0.0) {
        this.mute = true
      } else {
        this.mute = false
      }
    }
  },
  methods: {
    toggleVolumeBar () {
      this.isShowVolumeBar = !this.isShowVolumeBar
    },
    muted: function () {
      this.audio.muted = true
      this.preVolume = this.volume
      this.volume = 0
    },
    mutedNone: function () {
      this.audio.muted = false
      this.volume = this.preVolume
    },
    /**
     * volume bar を非表示にするためのメソッド
     */
    closeVolumeBar () {
      this.isShowVolumeBar = false
    }
  }
}
</script>
<style lang="scss" scoped>
.player-volume-wrap__volume-slider-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
input[type=range][orient=vertical]
{
  writing-mode: bt-lr; /* IE */
  -webkit-appearance: slider-vertical; /* WebKit */
  width: 8px;
  height: 100px;
  padding: 0 5px;
  position: absolute;
  top: -80px;
  right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/MuteBtn.vue